import { 
    ACCPSUPERVISOR_BEGIN,
    ACCPSUPERVISOR_ADD,
    ACCPSUPERVISOR_FAILURE,
    ACCPSUPERVISOR_CLEAR,

    ACCPSUPERVISOR_FILTER_BEGIN,
    ACCPSUPERVISOR_FILTER_SUCCESS,
    ACCPSUPERVISOR_FILTER_FAILURE,
    ACCPSUPERVISOR_FILTER_CLEAR,

    ACCPSUPERVISORAVAILABLE_ADD,
    ACCPSUPERVISORAVAILABLE_BEGIN,
    ACCPSUPERVISORAVAILABLE_FAILURE,
    ACCPSUPERVISORAVAILABLE_CLEAR

} from 'app/actions/ACCPSupervisorActions';

const initialState = {
    byId: {},
    allIds: [],
    filterData: [],
    byIdAvailable: {},
    allIdsAvailable: [],
    isLoading: false,
    isLoadingACCPSupervisorAvailable: false,
};

export default function ACCPSupervisorReducer (state = initialState, action) {
	switch (action.type) {
        case ACCPSUPERVISOR_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case ACCPSUPERVISOR_ADD:
            let allIds = action.payload.data.allIds;
			let byId = {
				...state.byId,
				...action.payload.data.byId
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
            };
        case ACCPSUPERVISOR_CLEAR:
            return {
                ...state,
                byId: {},
                allIds: [],
                isLoading: false,
            }
        case ACCPSUPERVISOR_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case ACCPSUPERVISOR_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case ACCPSUPERVISOR_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case ACCPSUPERVISOR_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case ACCPSUPERVISOR_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case ACCPSUPERVISORAVAILABLE_BEGIN:
            return {
                ...state,
                isLoadingACCPSupervisorAvailable: true
            }
        case ACCPSUPERVISORAVAILABLE_ADD:
            let allIdsAvailable = action.payload.data.Data;
            let byIdAvailable = {
                ...state.byIdAvailable,
            };
            return {
                ...state,
                allIdsAvailable,
                byIdAvailable,
                isLoadingACCPSupervisorAvailable: false,
            };
        case ACCPSUPERVISORAVAILABLE_CLEAR:
            return {
                ...state,
                byIdAvailable: {},
                allIdsAvailable: [],
                isLoadingACCPSupervisorAvailable: false,
            }
        case ACCPSUPERVISORAVAILABLE_FAILURE:
            return {
                ...state,
                isLoadingACCPSupervisorAvailable: false
            }
		default:
			return state;
	}
};

export const getACCPSupervisor = state => {
	return state.allIds.map( id => state.byId[id] );
}

export const getIsLoadingACCPSupervisor = state => {
    return state.isLoading;
}

export const getACCPSupervisorFilter = state => {
    return state.filterData
}
export const getIsLoadingACCPSupervisorFilter = state => {
    return state.isLoading;
}

export const getACCPSupervisorAvailable = state => {
    return state.allIdsAvailable;
}

export const getIsLoadingACCPSupervisorAvailable = state => {
    return state.isLoadingACCPSupervisorAvailable;
}
